import { ResponseWrapper, ErrorWrapper } from './util'

const news = [
  {
    id: 0,
    title: 'Начало редизайна/разработки проекта',
    content: '',
    date: '25/11/2017'
  },
  {
    id: 1,
    title: 'Первая публичная бета',
    content: '',
    date: '02/03/2018'
  }
]

export function getList () {
  return Promise.resolve(news)
    .then(data => {
      let response = { data }
      return new ResponseWrapper(response, response.data)
    })
    .catch(error => new ErrorWrapper(error))
}



// WEBPACK FOOTER //
// ./src/services/news.service.js